import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../../shared/components';
import CollegeAlgebraNavBar from './CollegeAlgebraNavBar';
import CollegeAlgebraFooter from './CollegeAlgebraFooter';
import Units from './Units';
import UnitDetail from './UnitDetail';
import LessonViewer from './LessonViewer';
import Quiz from './Quiz';
import Test from './Test';

// A second, self-contained page tree with its own title bar and footer --
// deliberately not nested inside the SAT Prep <NavBar>/<Routes> in App.js.
// App.js renders this instead of the SAT layout whenever the URL starts
// with /college-algebra (see the pathname check there), so this is the only
// place College Algebra's own routes are registered.
export default function CollegeAlgebraApp() {
  return (
    <div className="app-layout college-algebra-app">
      <CollegeAlgebraNavBar />
      <main className="app-content">
        <Routes>
          <Route path="/college-algebra" element={<ProtectedRoute element={<Units />} />} />
          <Route path="/college-algebra/units/:slug" element={<ProtectedRoute element={<UnitDetail />} />} />
          <Route path="/college-algebra/units/:slug/quiz" element={<ProtectedRoute element={<Quiz />} />} />
          <Route path="/college-algebra/units/:slug/test" element={<ProtectedRoute element={<Test />} />} />
          <Route path="/college-algebra/lessons/:slug" element={<ProtectedRoute element={<LessonViewer />} />} />
        </Routes>
      </main>
      <CollegeAlgebraFooter />
    </div>
  );
}
